import React, { createContext, useContext } from "react";
import { useCoreService } from "../../core/services/Core.service";
import { useAuthRepository } from "../repository/Auth.repository";
import { sessionStore } from "../states/session";


let operationsAllowed: any = {};
const AuthServiceContext = createContext(operationsAllowed);

export const AuthServiceProvider = (props: any) => {
  const authRepository = useAuthRepository();
  const coreService = useCoreService();
  const login = (crendentials: any) => {

    // TODO: call API to get the JWT token
    // authRepository.login(crendentials).then((result: any) => {

    // });
    sessionStore.login(crendentials);
  }

  const logout = () => {
    // TODOD: call API and then logout.
    // sessionStore.logout();
    coreService.tearDownApplication();
  }

  const createOrganization = (organization: any) => {
    return authRepository.createOrganization(organization);
  }

  operationsAllowed = {
    login,
    logout,
    createOrganization
  }

  return (
    <AuthServiceContext.Provider value={operationsAllowed}>
      {props.children}
    </AuthServiceContext.Provider>
  );
}

export const useAuthService = () => {
  return useContext(AuthServiceContext);
}